module.exports = __webpack_public_path__ + "img/2.46140d5d.webp";